import React, {
  useState,
  useEffect,
  useContext
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import Form from '~/containers/Form';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import useStyles from './styles';
import DoctorScheduleRecord from '~/records/DoctorScheduleRecord';
import DateFnsUtils from '@date-io/date-fns';
import InputCheckBox from '~/components/Input/InputCheckBox';
import InputDate from '~/components/Input/InputDate';
import {
  MuiPickersUtilsProvider,
  TimePicker,
} from '@material-ui/pickers';
import { Tooltip } from '@material-ui/core';
import moment from 'moment';
import timeToDate from '~/utils/timeToDate';
import {
  Info as InfoIcon
} from '@material-ui/icons';
import InputSelect from '~/components/Input/InputSelect';
import Request from '~/providers/Request';
import isPresent from '~/utils/isPresent';
import { useTranslation } from 'react-i18next';
import { AbilityContext } from '~/contexts/Can';

const attrName = (attr) => DoctorScheduleRecord.hummanAttributeName(attr);
function SpecialtyItem({ record, setRecord, handleChange, onSubmit, loading }) {
  const classesRoot = useStyles();
  const isPersisted = record.isPersisted();
  const [doctors, setDoctors] = useState([]);
  const { t } = useTranslation();
  const ability = useContext(AbilityContext);

  useEffect(() => {
    Request.get('/admin/users_doctors').then(({ data }) => {
      const items = data.map((user) => {
        if (user.specialties && user.specialties.length > 0) {
          const specialties = user.specialties.map(specialty => specialty.name).join(', ');
          return { id: Number(user.id), name: `${user.name} <${specialties}>` };
        }
      });
      setDoctors([
        ...items.filter(e => isPresent(e)),
        { id: null, name: t('medicalAppointments.extras.no_doctor') },
      ]);
    });
  }, []);

  const WeekDays = () => {
    return (
      <GridContainer>
        <GridItem md={1}>
          <InputControl
            value={record.get('is_sunday')}
            name="is_sunday"
            label={attrName('is_sunday')}
            inputComponent={InputCheckBox}
            onChange={handleChange}
            InputProps={{
              styleInput: {marginTop: 30}
            }}
          />
        </GridItem>
        <GridItem md={1}>
          <InputControl
            value={record.get('is_monday')}
            name="is_monday"
            label={attrName('is_monday')}
            inputComponent={InputCheckBox}
            onChange={handleChange}
            InputProps={{
              styleInput: {marginTop: 30}
            }}
          />
        </GridItem>
        <GridItem md={1}>
          <InputControl
            value={record.get('is_tuesday')}
            name="is_tuesday"
            label={attrName('is_tuesday')}
            inputComponent={InputCheckBox}
            onChange={handleChange}
            InputProps={{
              styleInput: {marginTop: 30}
            }}
          />
        </GridItem>
        <GridItem md={1}>
          <InputControl
            value={record.get('is_wednesday')}
            name="is_wednesday"
            label={attrName('is_wednesday')}
            inputComponent={InputCheckBox}
            onChange={handleChange}
            InputProps={{
              styleInput: {marginTop: 30}
            }}
          />
        </GridItem>
        <GridItem md={1}>
          <InputControl
            value={record.get('is_thursday')}
            name="is_thursday"
            label={attrName('is_thursday')}
            inputComponent={InputCheckBox}
            onChange={handleChange}
            InputProps={{
              styleInput: {marginTop: 30}
            }}
          />
        </GridItem>
        <GridItem md={1}>
          <InputControl
            value={record.get('is_friday')}
            name="is_friday"
            label={attrName('is_friday')}
            inputComponent={InputCheckBox}
            onChange={handleChange}
            InputProps={{
              styleInput: {marginTop: 30}
            }}
          />
        </GridItem>
        <GridItem md={1}>
          <InputControl
            value={record.get('is_saturday')}
            name="is_saturday"
            label={attrName('is_saturday')}
            inputComponent={InputCheckBox}
            onChange={handleChange}
            InputProps={{
              styleInput: {marginTop: 30}
            }}
          />
        </GridItem>
      </GridContainer>
    );
  };

  return (
    <>
      <Form onSubmit={onSubmit} >
        <Paper
          showHeader={false}
          Icon={LocalHospitalIcon}
          iconColor={isPersisted ? 'purple' : 'blue'}
          // title={t('doctor_schedules.defSingular')}
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>

            {ability.can('change_doctor', 'Schedules') && <GridContainer>
              <GridContainer>
                <GridItem>
                  <span style={{fontWeight: 100, fontSize: 20}}>{attrName('doctor')}</span>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem md={6}>
                  <InputControl
                    name={'doctor'}
                    value={record.get('doctor')}
                    required={true}
                    inputComponent={InputSelect}
                    onChange={({doctor}) => {
                      setRecord(record.updateAttributes({ doctor: doctor }));
                    }}
                    InputProps={{
                      options: doctors,
                      outValueType: 'object',
                    }}
                  />
                </GridItem>
              </GridContainer>
            </GridContainer>}

            <GridContainer style={{marginTop: ability.can('change_doctor', 'Schedules') ? 70 : -60}}>
              <GridContainer>
                <GridItem>
                  <span style={{fontWeight: 100, fontSize: 20}}>Intervalo de dias</span>
                </GridItem>
              </GridContainer>
              <GridItem xs={12} md={3}>
                <InputControl
                  value={record.get('begin_date') ? moment(record.get('begin_date')).format() : null}
                  name="begin_date"
                  label={attrName('begin_date')}
                  inputComponent={InputDate}
                  InputProps={{
                    type: 'date',
                  }}
                  onChange={(date) => setRecord(record.updateAttributes({ begin_date: moment(date).format() }))}
                />
              </GridItem>
              <GridItem xs={12} md={3}>
                <InputControl
                  value={record.get('end_date') ? moment(record.get('end_date')).format() : null}
                  name="end_date"
                  label={attrName('end_date')}
                  inputComponent={InputDate}
                  InputProps={{
                    type: 'date',
                  }}
                  onChange={(date) => setRecord(record.updateAttributes({ end_date: moment(date).format() }))}
                />
              </GridItem>
            </GridContainer>

            <GridContainer style={{marginTop: 50}}>
              <GridContainer>
                <GridItem>
                  <span style={{fontWeight: 100, fontSize: 20}}>Intervalo de horas</span>
                </GridItem>
              </GridContainer>
              <GridItem xs={12} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <TimePicker
                    label={attrName('begin_time')}
                    value={timeToDate(record.get('begin_time'))}
                    name="begin_time"
                    onChange={(time) => setRecord(record.updateAttributes({ begin_time: moment(time).format() }))}
                  />
                </MuiPickersUtilsProvider>
              </GridItem>
              <GridItem xs={12} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <TimePicker
                    label={attrName('end_time')}
                    value={timeToDate(record.get('end_time'))}
                    name="end_time"
                    onChange={(time) => setRecord(record.updateAttributes({ end_time: moment(time).format() }))}
                  />
                </MuiPickersUtilsProvider>
              </GridItem>
            </GridContainer>

            <GridContainer style={{marginTop: 50}}>
              <GridContainer>
                <GridItem>
                  <span style={{fontWeight: 100, fontSize: 20}}>Dias da semana</span>
                </GridItem>
              </GridContainer>
              <GridItem md={12}>
                <WeekDays />
              </GridItem>
            </GridContainer>

            <GridContainer style={{marginTop: 50}}>
              <GridContainer>
                <GridItem>
                  <span style={{fontWeight: 100, fontSize: 20}}>{attrName('is_closed')}</span>
                  <Tooltip title={'Restringe os valores informados.'} style={{marginLeft: 5, marginBottom: -5, color: '#bbb'}}>
                    <InfoIcon />
                  </Tooltip>
                </GridItem>
              </GridContainer>
              <GridItem xs={2} sm={2} md={2}>
                <InputControl
                  value={record.get('is_closed')}
                  name="is_closed"
                  // label={attrName('is_closed')}
                  inputComponent={InputCheckBox}
                  onChange={handleChange}
                  InputProps={{
                    styleInput: {marginTop: 30}
                  }}
                />
              </GridItem>
            </GridContainer>

          </div>
        </Paper>
      </Form>
    </>
  );
}

SpecialtyItem.propTypes = {
  record: PropTypes.instanceOf(DoctorScheduleRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

SpecialtyItem.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(SpecialtyItem));
